import ValidationUtils from './ValidationUtils';

const REQUIRED_ERROR_MESSAGE = 'This value is required';

const ForgotPasswordValidator = (values) => {
  const requiredFields = [{
    name: 'email',
    errorMessage: REQUIRED_ERROR_MESSAGE
  }];

  const errors = ValidationUtils.validateRequiredFields(requiredFields, values);

  if (values.email && !ValidationUtils.isValidEmailAddress(values.email)) {
    errors.email = 'Invalid email address';
  }

  return errors;
};

export default ForgotPasswordValidator;



/** WEBPACK FOOTER **
 ** ./src/common/validation/ForgotPasswordValidator.js
 **/